import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
    className?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ArrowOut: React.FC<Props> = ({ className, color, ...rest }) => (
    <svg
        className={className}
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}>
        <path d="M6.00024 3.5L10.5003 3.5L10.5004 7.99998" stroke={color} />
        <path d="M3 5.5H0.5V13.5H8.5V11" stroke={color} />
        <path d="M3 11L10.5 3.5" stroke={color} />
    </svg>
);
